import { RefetchCurrentUser, useAuth } from '@domain/auth/AuthContext';
import { CurrentUserFields } from '../../generated/graphql';
import { useClientHasRendered } from '@domain/session/useClientHasRendered';

export type CurrentUser = CurrentUserFields | null | undefined;

export interface UseUserInfo {
  isLoggedIn: boolean;
  isPremium: boolean;
  isVerified: boolean;
  user: CurrentUser;
  premiumEndDate: string | undefined;
  isLoadingUser: boolean;
  refetchCurrentUser: RefetchCurrentUser;
}

export function useUserInfo(): UseUserInfo {
  const { isLoggedIn, currentUser, refetchCurrentUser, isLoadingUser, premiumEndDate } = useAuth();
  const clientHasRendered = useClientHasRendered();

  return {
    isLoadingUser: clientHasRendered && isLoadingUser,
    isLoggedIn: clientHasRendered && isLoggedIn,
    isPremium: !!currentUser?.isPremium,
    isVerified: !!currentUser?.isVerified,
    user: currentUser,
    premiumEndDate,
    refetchCurrentUser,
  };
}
